/**
 * Get the appropriate price (HT or TTC) based on user concession status
 * @param {Object} product - The product object with priceHT, priceTTC, priceConcessionHT, priceConcessionTTC
 * @param {Object} user - The user object with concession property
 * @param {string} type - 'HT' or 'TTC'
 * @returns {number|null} - The appropriate price or null if not available
 */
export const getPrice = (product, user, type = 'HT') => {
  if (!product) return null;
  
  const isConcession = user?.concession === true;
  const priceType = type === 'HT' ? 'HT' : 'TTC';
  
  if (isConcession) {
    const concessionPrice = product[`priceConcession${priceType}`];
    // If concession price exists and is not null, use it
    if (concessionPrice !== null && concessionPrice !== undefined) {
      return concessionPrice;
    }
  }
  
  // Fallback to normal price
  return product[`price${priceType}`] || null;
};

/**
 * Get price HT based on user concession status
 * @param {Object} product - The product object
 * @param {Object} user - The user object with concession property
 * @returns {number|null} - The appropriate price HT or null
 */
export const getPriceHT = (product, user) => {
  return getPrice(product, user, 'HT');
};

/**
 * Get price TTC based on user concession status
 * @param {Object} product - The product object
 * @param {Object} user - The user object with concession property
 * @returns {number|null} - The appropriate price TTC or null
 */
export const getPriceTTC = (product, user) => {
  return getPrice(product, user, 'TTC');
};
